import TECFAD_EXT_1 from "./TECFAD_EXT_1";
export default {
  TECFAD_EXT_1,
};
